import { planStatusTextClass, type PlanStatus } from '@/components/ui/Tone'

/** ≥ 100 % — план выполнен, 80–99 % — близко, ниже — значительное отклонение. */
export function getPlanStatus(completion: number): PlanStatus {
  if (completion >= 100) return 'met'
  if (completion >= 80) return 'close'
  return 'missed'
}

export function getStatusColor(completion: number, plan = 1): string {
  if (plan === 0) return 'text-muted-foreground'
  return planStatusTextClass(getPlanStatus(completion))
}
